import React, { useState } from 'react';
import type { Brand } from '../data/brands';
type BrandLogoColor = 'white' | 'navy' | 'grey';
const HEX: Record<BrandLogoColor, string> = {
  white: 'ffffff',
  navy: '14356c',
  grey: '8a94a6'
};
type Props = {
  brand: Brand;
  color?: BrandLogoColor;
  /** rendered logo height in px (before per-brand optical scaling) */
  size?: number;
  className?: string;
};

/**
 * Renders the brand mark in the requested colour. Custom logo files are
 * recoloured with a CSS mask so the artwork carries no background and can be
 * shown white on navy or navy on white.
 */
export function BrandLogo({
  brand,
  color = 'navy',
  size = 32,
  className = ''
}: Props) {
  const [failed, setFailed] = useState(false);
  const height = size * (brand.logoScale ?? 1);
  if (failed) {
    return <span className={`font-heading font-semibold tracking-[0.18em] uppercase whitespace-nowrap ${className}`} style={{
      fontSize: Math.max(11, size * 0.42),
      color: `#${HEX[color]}`
    }} data-id="element-20" data-mp="ed8ul3iu726r">
        {brand.name}
      </span>;
  }
  if (brand.logoUrl) {
    const maskValue = `url(${brand.logoUrl}) no-repeat left center / contain`;
    return <span role="img" aria-label={`${brand.name} logotip`} className={`block ${className}`} style={{
      height,
      width: height * (brand.logoAspect ?? 3),
      backgroundColor: `#${HEX[color]}`,
      mask: maskValue,
      WebkitMask: maskValue
    }} data-id="element-21" data-mp="1a1zfbo13xfc5" />;
  }
  return <img src={`https://cdn.simpleicons.org/${brand.slug}/${HEX[color]}`} alt={`${brand.name} logotip`} style={{
    height
  }} className={`w-auto object-contain ${className}`} onError={() => setFailed(true)} loading="lazy" data-id="element-22" data-mp="1su1x52phj1nz" />;
}